import styled from 'styled-components';
import { HtmlAnchor } from '@atlassian/help-center-common-component/analytics/html-anchor';
import { ThemedLink } from '@atlassian/help-center-common-component/themed-link';

export const Link = styled(ThemedLink)`
    text-align: center;
`;

export const AnchorContainer = styled(HtmlAnchor)`
    text-align: center;
`;
